<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="logQuery">
                        <InputField label="" label-width="0" style="margin: 0.1rem 0.5rem 0.1rem 0;width:15%" type="text" id="code" v-model="form.code" placeholder="编码"
                                    @update:modelValue="(value) => handleModelValueUpdate('code', value)"
                        />
                        <InputField label="" label-width="0" style="margin: 0.1rem 0.5rem 0.1rem 0;width:15%" type="text" id="diameterRoom" v-model="form.diameterRoom" placeholder="井室直径"
                                    @update:modelValue="(value) => handleModelValueUpdate('diameterRoom', value)"
                        />
                        <SelectField label="" id="materialWell" label-width="0" placeholder="井材质"
                                     :modelValue="form.materialWell" :options="materialWellList" style="margin: 0.1rem 0.5rem 0.1rem 0;width: 15%"
                                     @update:modelValue="(value) => handleModelValueUpdate('materialWell', value)"
                        />
                        <SelectField label="" id="createAt" label-width="0" placeholder="年限"
                                     :modelValue="form.createAt" :options="createAtList" style="width: 15%"
                                     @update:modelValue="(value) => handleModelValueUpdate('createAt', value)"
                        />
                        <a-space style="margin: 0 0 0 0.5rem;width:25%">
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                            <ButtonField text="导出" @click="exportExcel" secondary />
                        </a-space>
                    </div>
                    <div class="right">
                        <ButtonField text="新建" @click="$emit('show-rain-well-add')" secondary />
                    </div>
                </div>
            </form>
        </div>
        <Tablelist
            style="margin-top: 1rem"
            :showCheckbox="false"
            :list="list"
            :totalSize="totalSize"
            :totalPages="totalPages"
            :pageNum="pageNum"
            :pageSize="pageSize"
            :columns="tableColumns"
            @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="$emit('show-rain-well-edit',item.id)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
    </div>
</template>
<script>
import * as XLSX from 'xlsx';
import { rainWellList, remove } from "../api/pipe-info.js";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            form: {},
            list: [],
            loading: false,
            total: 0,
            totalSize: 0,
            totalPages: 0,
            pageNum: 1,
            pageSize: 10,
            tableColumns: [
                { key: 'code', title: '编号', field: 'code', infotype: 'text' },
                { key: 'accessary', title: '附属物', field: 'accessary', infotype: 'text' },
                { key: 'diameterCover', title: '井盖直径', field: 'diameterCover', infotype: 'text' },
                { key: 'diameterRoom', title: '井室直径', field: 'diameterRoom', infotype: 'text' },
                { key: 'materialCover', title: '井盖材质', field: 'materialCover', infotype: 'text' },
                { key: 'materialWell', title: '检查井材质', field: 'materialWell', infotype: 'text' },
                { key: 'shapeCover', title: '井盖形状', field: 'shapeCover', infotype: 'text' },
                { key: 'depth', title: '井深(M)', field: 'depth', infotype: 'text' },
                { key: 'elevation', title: '地面高程', field: 'elevation', infotype: 'text' },
                { key: 'location', title: '所在道路', field: 'location', infotype: 'text' },
                { key: 'createAt', title: '创建年限', field: 'createAt', infotype: 'text' },
                { key: 'actions', title: '操作', infotype: 'template' }
            ],
            materialWellList: [
                { name: '砖石', value: '砖石' },
                { name: '混凝土', value: '混凝土' },
                { name: '聚乙烯塑料', value: '聚乙烯塑料' },
                { name: '聚氯乙烯塑料', value: '聚氯乙烯塑料' }
            ],
            createAtList: this.generateYearList(1990, new Date().getFullYear())
        };
    },
    mounted() {
        this.getList();
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        statusList() {
            return this.findDataDict("AssetReviewStatus");
        },
        typeList() {
            return this.findDataDict("pipeType");
        },
    },
    methods: {
        exportExcel() {
            this.loading = true; // 显示加载状态
            const { form } = this;
            // 请求所有数据：pageNum=1，pageSize设为极大值（如10000）确保获取全部
            rainWellList({
                pageNum: 1,
                pageSize: 10000,
                ...form
            })
                .then((res) => {
                    console.log("API返回数据：", res);
                    this.loading = false;
                    if (Array.isArray(res.list) && res.list.length > 0) {
                        const excelData = this.formatExcelData(res.list);
                        this.downloadExcel(excelData, "雨水井数据");
                    } else {
                        this.$message.warning("暂无数据可导出");
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("导出失败", error);
                    this.$message.error("导出失败，请重试");
                });
        },

        formatExcelData(rawList) {
            const excelHeaders = [
                { key: 'code', title: '编号' },
                { key: 'accessary', title: '附属物' },
                { key: 'diameterCover', title: '井盖直径' },
                { key: 'diameterRoom', title: '井室直径' },
                { key: 'location', title: '所在道路' },
                { key: 'materialCover', title: '井盖材质' },
                { key: 'materialWell', title: '检查井材质' },
                { key: 'shapeCover', title: '井盖形状' },
                { key: 'depth', title: '井深' },
                { key: 'elevation', title: '地面高程' },
                { key: 'createAt', title: '创建年限' },
            ];

            console.log("原始数据：", rawList);

            const formattedData = rawList.map(item => {
                const row = {};
                excelHeaders.forEach(header => {
                    row[header.title] = item[header.key] || "";
                });
                return row;
            });

            console.log("格式化后的数据：", formattedData);
            return formattedData; // 直接返回数据数组，不包含额外的表头行
        },

        downloadExcel(data, fileName) {
            try {
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(data);

                XLSX.utils.book_append_sheet(workbook, worksheet, "数据列表");

                const date = new Date().toLocaleDateString().replace(/\//g, "-");
                const fullFileName = `${fileName}_${date}.xlsx`;

                XLSX.writeFile(workbook, fullFileName);

                console.log("生成的文件名：", fullFileName);
            } catch (error) {
                console.error("下载Excel失败", error);
                this.$message.error("下载Excel失败，请重试");
            }
        },
        generateYearList(startYear, endYear) {
            const years = [];
            for (let year = endYear; year >= startYear; year--) {
                years.push({ name: year.toString(), value: year.toString() });
            }
            return years;
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        getList() {
            this.loading = true;
            let { form } = this;
            form.code = this.form.code;
            form.location = this.form.location;
            rainWellList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                ...form,
            })
                .then((res) => {
                    this.loading = false;
                    if (Array.isArray(res.list)) {
                        this.list = res.list;
                        this.totalSize = res.totalSize;
                        this.totalPages = res.totalPages;
                        res.list.forEach(item => {
                            if (item.createAt) {
                                const datePart = item.createAt.match(/^\d{4}-\d{2}-\d{2}/);
                                if (datePart) {
                                    item.createAt = datePart[0];
                                }
                            }
                        });
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("获取数据失败", error);
                    this.$message.error("获取数据失败，请重试");
                });
        },
        onChange(pagination) {
            this.pageNum = pagination;
            this.pageSize = 10;
            this.getList();
        },
        reset() {
            this.form = {};
            this.pageNum = 1;
            this.pageSize = 10;
            this.getList();
        },
        query() {
            this.pageNum = 1;
            this.pageSize = 10;
            this.getList();
        },
        deleteText(text) {
            const that = this;
            this.$confirm({
                title: "确认要删除吗？",
                onOk() {
                    remove({
                        id: text.id,
                        type: 'rain_well'
                    }).then(() => {
                        that.getList();
                    }).catch((error) => {
                        console.error("删除失败", error);
                        that.$message.error("删除失败，请重试");
                    });
                },
            });
        },
    },
};
</script>
<style lang="less" scoped>
.logQuery{
    display: flex;
    justify-content: start;
}
.right ::v-deep Button{
    margin: 0 0.2rem;
}
</style>